/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetSocialBilibiliUserinfoRequest = { uid: string };

export const GetSocialBilibiliUserinfoRequest$zodSchema: z.ZodType<
  GetSocialBilibiliUserinfoRequest
> = z.object({
  uid: z.string().describe("Bilibili用户的UID"),
});

export type GetSocialBilibiliUserinfoBadGatewayDetails = {};

export const GetSocialBilibiliUserinfoBadGatewayDetails$zodSchema: z.ZodType<
  GetSocialBilibiliUserinfoBadGatewayDetails
> = z.object({});

/**
 * 上游Bilibili API错误或风控
 */
export type GetSocialBilibiliUserinfoBadGatewayResponseBody = {
  code?: string | undefined;
  details?: GetSocialBilibiliUserinfoBadGatewayDetails | undefined;
  message?: string | undefined;
};

export const GetSocialBilibiliUserinfoBadGatewayResponseBody$zodSchema:
  z.ZodType<GetSocialBilibiliUserinfoBadGatewayResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetSocialBilibiliUserinfoBadGatewayDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("上游Bilibili API错误或风控");

export type GetSocialBilibiliUserinfoNotFoundDetails = {};

export const GetSocialBilibiliUserinfoNotFoundDetails$zodSchema: z.ZodType<
  GetSocialBilibiliUserinfoNotFoundDetails
> = z.object({});

/**
 * Bilibili用户不存在
 */
export type GetSocialBilibiliUserinfoNotFoundResponseBody = {
  code?: string | undefined;
  details?: GetSocialBilibiliUserinfoNotFoundDetails | undefined;
  message?: string | undefined;
};

export const GetSocialBilibiliUserinfoNotFoundResponseBody$zodSchema: z.ZodType<
  GetSocialBilibiliUserinfoNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetSocialBilibiliUserinfoNotFoundDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("Bilibili用户不存在");

export type GetSocialBilibiliUserinfoBadRequestDetails = {};

export const GetSocialBilibiliUserinfoBadRequestDetails$zodSchema: z.ZodType<
  GetSocialBilibiliUserinfoBadRequestDetails
> = z.object({});

/**
 * 缺少uid参数
 */
export type GetSocialBilibiliUserinfoBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetSocialBilibiliUserinfoBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetSocialBilibiliUserinfoBadRequestResponseBody$zodSchema:
  z.ZodType<GetSocialBilibiliUserinfoBadRequestResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetSocialBilibiliUserinfoBadRequestDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("缺少uid参数");

export type GetSocialBilibiliUserinfoData = {
  face?: string | undefined;
  level?: number | undefined;
  mid?: number | undefined;
  name?: string | undefined;
  sex?: string | undefined;
  sign?: string | undefined;
};

export const GetSocialBilibiliUserinfoData$zodSchema: z.ZodType<
  GetSocialBilibiliUserinfoData
> = z.object({
  face: z.string().optional(),
  level: z.int().optional(),
  mid: z.int().optional(),
  name: z.string().optional(),
  sex: z.string().optional(),
  sign: z.string().optional(),
});

/**
 * 查询成功！返回用户的详细信息。请注意，我们直接透传了B站官方API的返回结构。
 */
export type GetSocialBilibiliUserinfoResponseBody = {
  code?: number | undefined;
  data?: GetSocialBilibiliUserinfoData | undefined;
  message?: string | undefined;
};

export const GetSocialBilibiliUserinfoResponseBody$zodSchema: z.ZodType<
  GetSocialBilibiliUserinfoResponseBody
> = z.object({
  code: z.int().optional(),
  data: z.lazy(() => GetSocialBilibiliUserinfoData$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "查询成功！返回用户的详细信息。请注意，我们直接透传了B站官方API的返回结构。",
);

export type GetSocialBilibiliUserinfoResponse =
  | GetSocialBilibiliUserinfoResponseBody
  | GetSocialBilibiliUserinfoBadRequestResponseBody
  | GetSocialBilibiliUserinfoNotFoundResponseBody
  | GetSocialBilibiliUserinfoBadGatewayResponseBody;

export const GetSocialBilibiliUserinfoResponse$zodSchema: z.ZodType<
  GetSocialBilibiliUserinfoResponse
> = z.union([
  z.lazy(() => GetSocialBilibiliUserinfoResponseBody$zodSchema),
  z.lazy(() => GetSocialBilibiliUserinfoBadRequestResponseBody$zodSchema),
  z.lazy(() => GetSocialBilibiliUserinfoNotFoundResponseBody$zodSchema),
  z.lazy(() => GetSocialBilibiliUserinfoBadGatewayResponseBody$zodSchema),
]);
